/**
 * Pill-style filter tabs. `count` is optional per tab and only renders when a
 * number is supplied (gated counts stay hidden until backend totals exist).
 *
 * tabs: [{ value, label, count? }]
 */
export function FilterTabs({ tabs, value, onChange, ariaLabel = 'Filters' }) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="inline-flex w-max shrink-0 flex-nowrap items-center gap-2"
    >
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value === '' || tab.value == null ? 'all' : tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={`inline-flex h-9 items-center gap-1.5 rounded-md border px-3 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A6D6]/40 ${
              active
                ? 'border-[#00A6D6] bg-[#EEF4FF] text-[#003A70]'
                : 'border-[#D1D5DB] bg-white text-[#1F2933] hover:bg-[#F4F7FA]'
            }`}
          >
            {tab.label}
            {typeof tab.count === 'number' ? (
              <span
                className={`inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-xs font-semibold ${
                  active ? 'bg-[#00A6D6] text-white' : 'bg-[#F4F7FA] text-[#5A5A5A]'
                }`}
              >
                {tab.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
